import Vue from 'vue'
import VueRouter from 'vue-router'

// 重写路由push方法 捕捉重复路由报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: () => import('../views/Index.vue'),
  },
  {
    path: '/ExamList',
    name: 'ExamList',
    component: () => import('../views/ExamList.vue'),
  },
  {
    path: '/SelectExam',
    name: 'SelectExam',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/SelectExam.vue')
    }
  },
  {
    path: '/Login',
    name: 'Login',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Login.vue')
    }
  },
  {
    path: '/GuidePage',
    name: 'GuidePage',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/GuidePage.vue')
    }
  },
  {
    path: '/PassWordEdit',
    name: 'PassWordEdit',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/PassWordEdit.vue')
    }
  },
  {
    path: '/ExamedList',
    name: 'ExamedList',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/ExamedList.vue')
    }
  },
  {
    path: '/StartExam',
    name: 'StartExam',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/StartExam.vue')
    }
  },
  {
    path: '/CheckExamAnswer',
    name: 'CheckExamAnswer',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/CheckExamAnswer.vue')
    }
  },
  {
    path: '/ExamOutline',
    name: 'ExamOutline',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/ExamOutline.vue')
    }
  },
  {
    path: '/Brand',
    name: 'Brand',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Brand.vue')
    }
  },
  {
    path: '/UploadFile',
    name: 'UploadFile',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/UploadFile.vue')
    }
  },
  {
    path: '/UploadFileDetail',
    name: 'UploadFileDetail',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/UploadFileDetail.vue')
    }
  },
  {
    path: '/OutlineDetail',
    name: 'OutlineDetail',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/OutlineDetail.vue')
    }
  },
  {
    path: '/MySource',
    name: 'MySource',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/MySource.vue')
    }
  },
  {
    path: '/ComputerPage',
    name: 'ComputerPage',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/ComputerPage.vue')
    }
  },
  {
    path: '/categoryDetail',
    name: 'categoryDetail',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/categoryDetail.vue')
    }
  },
  {
    path: '/ExamedListDetail',
    name: 'ExamedListDetail',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/ExamedListDetail.vue')
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes
})

router.beforeEach((to, from, next) => {
  let isp = /^\/UploadFile/.test(to.path)
  if (to.path === '/OutlineDetail'||to.path === '/'||to.path === '/Login'||to.path === '/ExamOutline'||to.path === '/ComputerPage'||to.path === '/Brand'||to.path === '/UploadFile'||isp) return next() // 访问登录页，直接放行
  console.log(to)
  const permission = sessionStorage.getItem('token')
  if (!permission){
    return next({
      path: '/Login',
      query: { redirect: to.fullPath }  // 将原来的路由保存在 query 中
    }) // 没有登录强制跳转
  }
  next()
})

export default router
